import { defaultListParams } from '../../../../common/filterTable/constants/defaultListParams';
import { cleanParams } from '../../../../common/filterTable/helpers/cleanParams';
import { DatePickerReturnType } from '../../../../components/DatePicker';
import useChains from '../../../../hooks/useChains';
import { FilterFields } from '../types/FilterFields';
import { GetListParams } from '../types/GetListParams';

const useGetListParams = (
  CreatedDate: DatePickerReturnType,
  LastModifiedDate: DatePickerReturnType
) => {
  const { getChainInfoById } = useChains();

  const getListParams = (fields: FilterFields) => {
    const {
      // Date range filters (from DatePicker sync)
      chain,
      assetName,
      batchId,
    } = fields;

    // const [decodedChainType, decodedChainId] = assetSelection.split('|');
    const chainInfo = getChainInfoById(chain);

    const { start: createdDateFrom, end: createdDateTo } = CreatedDate;
    const { start: lastModifiedDateFrom, end: lastModifiedDateTo } = LastModifiedDate;

    const params: GetListParams = {
      ...defaultListParams,
      createdDateFrom,
      createdDateTo,
      lastModifiedDateFrom,
      lastModifiedDateTo,

      chainType: chainInfo?.chainType,
      chainId: chainInfo?.chainId,
      assetName: assetName,
      batchId,
      operationType: fields.operationType,
      status: fields.status,
      merchantIds: fields.merchantNames,
    };

    return cleanParams(params);
  };

  return {
    getListParams,
  };
};

export default useGetListParams;
